export const fr = {
    'ROLE_FILTER.LABEL': 'Filtrer les rôles',
    'ROLE_FILTER.SHOW_ALL': 'Afficher tous les rôles',
    'ROLE_FILTER.ELEVATED': 'Rôles élevés',
    'ROLE_FILTER.ROLE_COUNT': '{[{ count }]} rôles',
    'ROLE_FILTER.SELECT_ALL': 'Sélectionner tous les rôles',
    'ROLE_FILTER.SELECT_ELEVATED': 'Sélectionner les rôles élevés',
    'ROLE_FILTER.CLEAR': 'Effacer la sélection',
    'ROLES.ADMIN': 'Administrateur',
    'ROLES.REPORTER': 'Reporter',
    'ROLES.VR_USER': 'Utilisateur VR',
    'ROLES.EVENT_MANAGER': "Gestionnaire d'événements",
    'ROLES.EVENT_CURATOR': "Superviseur d'Événement",
    'ROLES.BC_USER': 'Utilisateur BC',
    'ROLES.BC_MANAGER': 'Gestionnaire BC',
    'ROLES.DA_USER': 'Utilisateur DA',
    'ROLES.DA_MANAGER': 'Gestionnaire DA',
    'ROLES.LR_USER': 'Utilisateur LR',
};
